import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'titleCase'
})
export class TitleCasePipe implements PipeTransform {
    transform(value: any) {
        if (!value) return null;

        let words = value.trim().split(' ');
        for (let i = 0; i < words.length; i++) {
            words[i] = words[i].trim().substr(0, 1).toUpperCase() + words[i].trim().substr(1).toLowerCase()
        }

        return words.join(' ');
    }
}